const Util = {};

Util.NodeTypes = {
  ELEMENT_NODE: 1,
  ATTRIBUTE_NODE: 2,
  TEXT_NODE: 3,
  CDATA_SECTION_NODE: 4,
  ENTITY_REFERENCE_NODE: 5,
  ENTITY_NODE: 6,
  PROCESSING_INSTRUCTION_NODE: 7,
  COMMENT_NODE: 8,
  DOCUMENT_NODE: 9,
  DOCUMENT_TYPE_NODE: 10,
  DOCUMENT_FRAGMENT_NODE: 11,
  NOTATION_NODE: 12
};

const findStartTextNode = (element) => {
    if(element.hasChildNodes()) {
      return findStartTextNode(element.childNodes[0]);
    } else if(element.nodeType == Util.NodeTypes.TEXT_NODE) {
      return element;
    } else {
      return findStartTextNode(element.nextSibling);
    }
}

const findEndTextNode = (element) => {
  if(element.hasChildNodes()) {
    return findEndTextNode(element.childNodes[0]);
  } else if(element.nodeType == Util.NodeTypes.TEXT_NODE) {
    return element;
  } else {
    return findEndTextNode(element.previousSibling);
  }
}

const normalize = (range) => {

    const _range = range.cloneRange();

    if(range.startContainer.nodeType == Util.NodeTypes.ELEMENT_NODE) {
      const s = range.commonAncestorContainer.childNodes[range.startOffset];
      const startEl = findStartTextNode(s);
      _range.setStart(startEl, 0);
    }

    if(range.endContainer.nodeType == Util.NodeTypes.ELEMENT_NODE) {
      const e = range.commonAncestorContainer.childNodes[range.endOffset];
      const endEl = findEndTextNode(e);
      _range.setEnd(endEl, endEl.length);
    }

  return _range;
};

export default {normalize: normalize};